unit View.Ncm.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, WEBLib.Lists, WEBLib.Grids, Grid.Plugins, System.StrUtils,
  UConstantes, WEBLib.WebCtrls, UUtils, UWeb.Enum;

type
  TFViewNcmEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbncm: TLabel;
    edncm: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lbdata_inicio_vigencia: TLabel;
    lbdata_fim_vigencia: TLabel;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientNcmGet: TXDataWebClient;
    NcmDataset: TXDataWebDataSet;
    NcmDatasetid: TIntegerField;
    NcmDatasetncm: TStringField;
    NcmDatasetdescricao: TStringField;
    NcmDatasetdata_inicio_vigencia: TDateTimeField;
    NcmDatasetdata_fim_vigencia: TDateTimeField;
    NcmDatasetexcluido: TBooleanField;
    NcmDatasetinclusao: TDateTimeField;
    NcmDatasetalteracao: TDateTimeField;
    NcmDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    btnIbptaxTab: TButton;
    btnNcmTab: TButton;
    pnlEspacoFormNcm: TPanel;
    pnlIbptax: TPanel;
    lbTotalIbptax: TLabel;
    cbPageSizeIbptax: TComboBox;
    ibptax_search: TEdit;
    tblIbptax: TDBTableControl;
    wlcIbptax: TListControl;
    dtsIbptax: TDataSource;
    cdsIbptax: TXDataWebDataSet;
    tmrConsultaIbptax: TTimer;
    cdsIbptaxid: TIntegerField;
    cdsIbptaxncm_id: TIntegerField;
    cdsIbptaxuf_id: TIntegerField;
    cdsIbptaxtipo: TIntegerField;
    cdsIbptaxaliquota_federal: TFloatField;
    cdsIbptaxaliquota_importacao_federal: TFloatField;
    cdsIbptaxaliquota_estadual: TFloatField;
    cdsIbptaxaliquota_municipal: TFloatField;
    cdsIbptaxdata_vigencia_inicio: TDateTimeField;
    cdsIbptaxdata_vigencia_fim: TDateTimeField;
    cdsIbptaxchave: TStringField;
    cdsIbptaxversao: TStringField;
    cdsIbptaxfonte: TStringField;
    cdsIbptaxexcluido: TBooleanField;
    cdsIbptaxinclusao: TDateTimeField;
    cdsIbptaxalteracao: TDateTimeField;
    cdsIbptaxexclusao: TDateTimeField;
    cdsIbptaxufSigla: TXDataWebDatasetField;
    pnlEspacoFormIbptax: TPanel;
    dtsIbptaxEdit: TDataSource;
    cdsIbptaxEdit: TXDataWebDataSet;
    cdsIbptaxEditid: TIntegerField;
    cdsIbptaxEditncm_id: TIntegerField;
    cdsIbptaxEdituf_id: TIntegerField;
    cdsIbptaxEdittipo: TIntegerField;
    cdsIbptaxEditaliquota_federal: TFloatField;
    cdsIbptaxEditaliquota_importacao_federal: TFloatField;
    cdsIbptaxEditaliquota_estadual: TFloatField;
    cdsIbptaxEditaliquota_municipal: TFloatField;
    cdsIbptaxEditdata_vigencia_inicio: TDateTimeField;
    cdsIbptaxEditdata_vigencia_fim: TDateTimeField;
    cdsIbptaxEditchave: TStringField;
    cdsIbptaxEditversao: TStringField;
    cdsIbptaxEditfonte: TStringField;
    cdsIbptaxEditexcluido: TBooleanField;
    cdsIbptaxEditinclusao: TDateTimeField;
    cdsIbptaxEditalteracao: TDateTimeField;
    cdsIbptaxEditexclusao: TDateTimeField;
    WebLabel1: TLabel;
    WebDBEdit1: TDBEdit;
    lbtipo: TLabel;
    lbaliquota_federal: TLabel;
    edaliquota_federal: TDBEdit;
    lbaliquota_importacao_federal: TLabel;
    edaliquota_importacao_federal: TDBEdit;
    lbaliquota_estadual: TLabel;
    edaliquota_estadual: TDBEdit;
    lbaliquota_municipal: TLabel;
    edaliquota_municipal: TDBEdit;
    lbdata_vigencia_inicio: TLabel;
    eddata_vigencia_inicio: TDBEdit;
    lbdata_vigencia_fim: TLabel;
    eddata_vigencia_fim: TDBEdit;
    lbchave: TLabel;
    edchave: TDBEdit;
    lbversao: TLabel;
    edversao: TDBEdit;
    lbfonte: TLabel;
    edfonte: TDBEdit;
    cdsIbptaxEditufSigla: TXDataWebDatasetField;
    cbbTipo: TComboBox;
    WebLabel3: TLabel;
    WebDBEdit2: TDBEdit;
    WebLabel2: TLabel;
    cbExcluidoIbptax: TDBCheckBox;
    WebLabel5: TLabel;
    WebLabel4: TLabel;
    WebDBEdit4: TDBEdit;
    WebDBEdit3: TDBEdit;
    edtUfSigla: TDBEdit;
    lbuf_id: TLabel;
    eddata_inicio_vigencia: TDBDateTimePicker;
    eddata_fim_vigencia: TDBDateTimePicker;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientNcmGetLoad(Response: TXDataClientResponse);
    procedure XDataClientNcmDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientNcmDeleteError(Error: TXDataClientError);
    procedure NcmDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure btnIbptaxTabClick(Sender: TObject);
    procedure tblIbptaxGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure tblIbptaxGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblIbptaxGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tmrConsultaIbptaxTimer(Sender: TObject);
    procedure cbPageSizeIbptaxChange(Sender: TObject);
    procedure ibptax_searchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure ibptax_searchKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cdsIbptaxEditAfterOpen(DataSet: TDataSet);
    procedure edncmKeyPress(Sender: TObject; var Key: Char);
    procedure edncmClick(Sender: TObject);
    procedure eddescricaoClick(Sender: TObject);
    procedure eddata_inicio_vigenciaClick(Sender: TObject);
    procedure eddata_fim_vigenciaClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginIbptx : TGridPlugin;

    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure DesabilitarCampos;
    function ValidarCampos : TArray<string>;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewNcmEdit: TFViewNcmEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNcmEdit }

procedure TFViewNcmEdit.btnIbptaxTabClick(Sender: TObject);
begin
  if not Assigned(FGridPluginIbptx) then
  begin
    FGridPluginIbptx := TGridPlugin.Create(tblIbptax, cdsIbptax, wlcIbptax, lbTotalIbptax);
    FGridPluginIbptx.FDatasetPlugin.FOrderByPadrao := 'alteracao desc';
    FGridPluginIbptx.FDatasetPlugin.FFilterPadrao := 'ncm_id eq ' + edid.Text;
    FGridPluginIbptx.SetPageSize(StrToInt(cbPageSizeIbptax.Text));
    FGridPluginIbptx.SetFilterText(ibptax_search.Text);
  end;

  FGridPluginIbptx.Load;
end;

procedure TFViewNcmEdit.btSaveClick(Sender: TObject);
var
  lErro : TArray<string>;
  lTipoOperacao : string;
begin
  lErro := ValidarCampos;

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  lTipoOperacao := 'cadastrar';

  if not FInserting then
    lTipoOperacao := 'editar';

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' +
    lTipoOperacao + ' este NCM?')) then
  begin
    if NcmDataset.State in dsEditModes then
    begin
      TUtils.ChamarDivLoading;

      if FInserting then
        NcmDataset.FieldByName('data_inicio_vigencia').AsDateTime := eddata_inicio_vigencia.Date;

      if DateToStr(eddata_fim_vigencia.Date) <> '30/12/1899' then
      begin
        if StrToDate(FormatDateTime('dd/mm/yyyy', eddata_fim_vigencia.Date)) <= Date then
          NcmDataset.FieldByName('excluido').AsBoolean := True
        else
          NcmDataset.FieldByName('excluido').AsBoolean := False;
      end;

      NcmDataset.Post;
      NcmDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

procedure TFViewNcmEdit.cbPageSizeIbptaxChange(Sender: TObject);
begin
  FGridPluginIbptx.SetPageSize(StrToInt(cbPageSizeIbptax.Text), True);
end;

procedure TFViewNcmEdit.cdsIbptaxEditAfterOpen(DataSet: TDataSet);
begin
  asm
    $('#modal_ibptax').modal('show');
  end;
end;

class function TFViewNcmEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewNcmEdit.DesabilitarCampos;
begin
  edncm.Enabled := False;
  eddata_inicio_vigencia.Enabled := False;
  eddata_fim_vigencia.Enabled := False;
  eddescricao.Enabled := False;
  cbExcluido.Enabled := False;
end;

procedure TFViewNcmEdit.eddata_fim_vigenciaClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_ncm_form_lbdata_fim_vigencia');
end;

procedure TFViewNcmEdit.eddata_inicio_vigenciaClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_ncm_form_lbdata_inicio_vigencia');
end;

procedure TFViewNcmEdit.eddescricaoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_ncm_form_lbdescricao');
end;

procedure TFViewNcmEdit.edncmClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_ncm_form_lbncm');
end;

procedure TFViewNcmEdit.edncmKeyPress(Sender: TObject; var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewNcmEdit.ibptax_searchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaIbptax.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginIbptx.SetFilterText(ibptax_search.Text, True);
  end;
end;

procedure TFViewNcmEdit.ibptax_searchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaIbptax.Interval := FTimerConsulta;
  tmrConsultaIbptax.Enabled := True;
end;

procedure TFViewNcmEdit.InsertEntity;
begin
  NcmDataset.Close;
  NcmDataset.SetJsonData('{}');
  NcmDataset.Open;
  NcmDataset.Insert;
end;

class function TFViewNcmEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNcmEdit(AForm).FInserting := AInserting;
    TFViewNcmEdit(AForm).FId := AId;
    TFViewNcmEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewNcmEdit(AForm).InsertEntity
    else
      TFViewNcmEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewNcmEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewNcmEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    NcmDataset.Connection.Model.DefaultSchema.FindEntityType(
      NcmDataset.EntitySetName
    )
  );
  XDataClientNcmGet.Get(NcmDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewNcmEdit.ShowNotification(Notification: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Notification);
end;

procedure TFViewNcmEdit.tblIbptaxGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId,
  RecordCdsCurrent: JSValue;
  RecordTipo : string;


  procedure EditButtonClick(Sender: TObject);
  begin
    if (RecordTipo = 'null') or (Trim(RecordTipo) = '') then
      cbbTipo.ItemIndex := 2
    else if StrToInt(RecordTipo) in [1,2] then
      cbbTipo.ItemIndex := 1
    else
      cbbTipo.ItemIndex := 0;

    cdsIbptaxEdit.Close;
    cdsIbptaxEdit.SetJsonData(RecordCdsCurrent);
    cdsIbptaxEdit.Open;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblIbptax.Columns[ACol].Title = 'Ação' then
  begin
    RecordCdsCurrent := cdsIbptax.CurrentData;
    RecordTipo := cdsIbptax.FieldByName('tipo').AsString;

    RecordId := TCrudUtils.GetIdFromObject(
      cdsIbptax.Connection.Model.DefaultSchema.FindEntityType(cdsIbptax.EntitySetName),
      cdsIbptax.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_ibptax');
  end;
end;

procedure TFViewNcmEdit.tblIbptaxGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblIbptax.Columns[ACol].DataField, ['tipo', 'chave', 'versao', 'fonte',
      'aliquota_federal', 'aliquota_importacao_federal', 'aliquota_estadual', 'aliquota_municipal']) of
      0, 1, 2, 3: AClassName := 'text-left';
      4, 5, 6, 7: AClassName := 'text-end';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewNcmEdit.tblIbptaxGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblIbptax.Columns[ACol].DataField, ['excluido', 'tipo']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        if (AValue <> 'null') and (Trim(AValue) <> '') then
        begin
          case StrToInt(AValue) of
            0 : AValue := 'Produtos';
            1, 2 : AValue := 'Serviços';
          end;
        end;
      end;
    end;
  end;
end;

procedure TFViewNcmEdit.tmrConsultaIbptaxTimer(Sender: TObject);
begin
  FGridPluginIbptx.SetFilterText(ibptax_search.Text, True);

  tmrConsultaIbptax.Enabled := False;
  tmrConsultaIbptax.Interval := FTimerConsulta;
end;

function TFViewNcmEdit.ValidarCampos: TArray<string>;
begin
  TUtils.LimparErrosClass;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := 'view_ncm_form_lbncm';

  if Trim(edncm.Text) = '' then
  begin
    Result[0] := 'NCM não pode ser vazio!';
    Result[1] := 'view_ncm_form_lbncm';
    Exit;
  end;

   if DateToStr(eddata_inicio_vigencia.Date) = '30/12/1899' then
   begin
     Result[0] := 'Data de inicio da vigência não pode ser vazia!';
     Result[1] := 'view_ncm_form_lbdata_inicio_vigencia';
     Exit;
   end;


  if (Trim(eddata_inicio_vigencia.Text) <> '') and (Trim(eddata_fim_vigencia.Text) <> '') then
  begin
    if eddata_inicio_vigencia.Date > eddata_fim_vigencia.Date  then
    begin
      Result[0] := 'Data de inicio não pode ser maior que a de fim!';
      Result[1] := 'view_ncm_form_lbdata_inicio_vigencia';
      Exit;
    end;
  end;

  if Trim(eddescricao.Text) = '' then
  begin
    Result[0] := 'Descrição do ncm não pode ser vazia!';
    Result[1] := 'view_ncm_form_lbdescricao';
    Exit;
  end;
end;

procedure TFViewNcmEdit.WebFormShow(Sender: TObject);
begin
  if FInserting or not TUtils.PossuiPermissao(cdsIbptax.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId(btnIbptaxTab.ElementID);
    THelperServer.RemoverElementoPorId('line-ibptax');
    THelperServer.RemoverElementoPorId('modal_ibptax');
  end;


  if FInserting then
  begin
    eddata_inicio_vigencia.Date := Date;

    THelperServer.RemoverElementoPorId('div_campos_visualizar');

    if edncm.CanFocus then
      edncm.SetFocus;
  end
  else
  begin
    if not TUtils.PossuiPermissao(NcmDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      btSave.Enabled := False;
      DesabilitarCampos;
    end;
  end;
end;

procedure TFViewNcmEdit.XDataClientNcmGetLoad(Response: TXDataClientResponse);
begin
  NcmDataset.Close;
  NcmDataset.SetJsonData(Response.Result);
  NcmDataset.Open;
  
  NcmDataset.Edit;  
end;

procedure TFViewNcmEdit.XDataClientNcmDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewNcmEdit.XDataClientNcmDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewNcmEdit.NcmDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];

    if ResolveInfo.Error <> '' then
    begin
      if Pos('Duplicate entry', ResolveInfo.Error) > 0  then
      begin
        TUtils.OcultarDivLoading;
        TUtils.SetErroClass('view_ncm_form_lbncm', 'NCM já cadastrado no servidor!');
      end
      else
        ShowNotification(ResolveInfo.Error);

      NcmDataset.Edit;

      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FShowListProc;
end;

procedure TFViewNcmEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewNcmEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.ncm.form.lbid');
  lbncm := TLabel.Create('view.ncm.form.lbncm');
  lbdescricao := TLabel.Create('view.ncm.form.lbdescricao');
  lbdata_inicio_vigencia := TLabel.Create('view.ncm.form.lbdata_inicio_vigencia');
  lbdata_fim_vigencia := TLabel.Create('view.ncm.form.lbdata_fim_vigencia');
  lbexcluido := TLabel.Create('view.ncm.form.lbexcluido');
  lbinclusao := TLabel.Create('view.ncm.form.lbinclusao');
  lbalteracao := TLabel.Create('view.ncm.form.lbalteracao');
  lbexclusao := TLabel.Create('view.ncm.form.lbexclusao');
  lbTotalIbptax := TLabel.Create('ibptax_paginacao_info');
  WebLabel1 := TLabel.Create('view.ncm_ibptax.form.lbid');
  lbtipo := TLabel.Create('view.ncm_ibptax.form.lbtipo');
  lbaliquota_federal := TLabel.Create('view.ncm_ibptax.form.lbaliquota_federal');
  lbaliquota_importacao_federal := TLabel.Create('view.ncm_ibptax.form.lbaliquota_importacao_federal');
  lbaliquota_estadual := TLabel.Create('view.ncm_ibptax.form.lbaliquota_estadual');
  lbaliquota_municipal := TLabel.Create('view.ncm_ibptax.form.lbaliquota_municipal');
  lbdata_vigencia_inicio := TLabel.Create('view.ncm_ibptax.form.lbdata_vigencia_inicio');
  lbdata_vigencia_fim := TLabel.Create('view.ncm_ibptax.form.lbdata_vigencia_fim');
  lbchave := TLabel.Create('view.ncm_ibptax.form.lbchave');
  lbversao := TLabel.Create('view.ncm_ibptax.form.lbversao');
  lbfonte := TLabel.Create('view.ncm_ibptax.form.lbfonte');
  WebLabel3 := TLabel.Create('view.ncm_ibptax.form.lbinclusao');
  WebLabel2 := TLabel.Create('view.ncm_ibptax.form.lbexcluido');
  WebLabel5 := TLabel.Create('view.ncm_ibptax.form.lbexclusao');
  WebLabel4 := TLabel.Create('view.ncm_ibptax.form.lbalteracao');
  lbuf_id := TLabel.Create('view.ncm_ibptax.form.lbuf_id');
  btCancel := TButton.Create('view.ncm.form.btBack');
  btSave := TButton.Create('view.ncm.form.btSave');
  edid := TDBEdit.Create('view.ncm.form.edid');
  edncm := TDBEdit.Create('view.ncm.form.edncm');
  eddescricao := TDBEdit.Create('view.ncm.form.eddescricao');
  edinclusao := TDBEdit.Create('view.ncm.form.edinclusao');
  edalteracao := TDBEdit.Create('view.ncm.form.edalteracao');
  edexclusao := TDBEdit.Create('view.ncm.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.ncm.form.cbexcluido');
  btnIbptaxTab := TButton.Create('line-ibptax-tab');
  btnNcmTab := TButton.Create('line-ncm-tab');
  pnlEspacoFormNcm := TPanel.Create(Self);
  pnlIbptax := TPanel.Create(Self);
  cbPageSizeIbptax := TComboBox.Create('ibptax_page_size');
  ibptax_search := TEdit.Create('ibptax_search');
  tblIbptax := TDBTableControl.Create('ibptax_table');
  wlcIbptax := TListControl.Create('ibptax_list_paginacao');
  pnlEspacoFormIbptax := TPanel.Create(Self);
  WebDBEdit1 := TDBEdit.Create('view.ncm_ibptax.form.edid');
  edaliquota_federal := TDBEdit.Create('view.ncm_ibptax.form.edaliquota_federal');
  edaliquota_importacao_federal := TDBEdit.Create('view.ncm_ibptax.form.edaliquota_importacao_federal');
  edaliquota_estadual := TDBEdit.Create('view.ncm_ibptax.form.edaliquota_estadual');
  edaliquota_municipal := TDBEdit.Create('view.ncm_ibptax.form.edaliquota_municipal');
  eddata_vigencia_inicio := TDBEdit.Create('view.ncm_ibptax.form.eddata_vigencia_inicio');
  eddata_vigencia_fim := TDBEdit.Create('view.ncm_ibptax.form.eddata_vigencia_fim');
  edchave := TDBEdit.Create('view.ncm_ibptax.form.edchave');
  edversao := TDBEdit.Create('view.ncm_ibptax.form.edversao');
  edfonte := TDBEdit.Create('view.ncm_ibptax.form.edfonte');
  cbbTipo := TComboBox.Create('cbbTipo');
  WebDBEdit2 := TDBEdit.Create('view.ncm_ibptax.form.edinclusao');
  cbExcluidoIbptax := TDBCheckBox.Create('cbExcluidoIbptax');
  WebDBEdit4 := TDBEdit.Create('view.ncm_ibptax.form.edexclusao');
  WebDBEdit3 := TDBEdit.Create('view.ncm_ibptax.form.edalteracao');
  edtUfSigla := TDBEdit.Create('edtUfSigla');
  eddata_inicio_vigencia := TDBDateTimePicker.Create('view.ncm.form.eddata_inicio_vigencia');
  eddata_fim_vigencia := TDBDateTimePicker.Create('view.ncm.form.eddata_fim_vigencia');
  DataSource := TDataSource.Create(Self);
  NcmDataset := TXDataWebDataSet.Create(Self);
  NcmDatasetid := TIntegerField.Create(Self);
  NcmDatasetncm := TStringField.Create(Self);
  NcmDatasetdescricao := TStringField.Create(Self);
  NcmDatasetdata_inicio_vigencia := TDateTimeField.Create(Self);
  NcmDatasetdata_fim_vigencia := TDateTimeField.Create(Self);
  NcmDatasetexcluido := TBooleanField.Create(Self);
  NcmDatasetinclusao := TDateTimeField.Create(Self);
  NcmDatasetalteracao := TDateTimeField.Create(Self);
  NcmDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientNcmGet := TXDataWebClient.Create(Self);
  dtsIbptax := TDataSource.Create(Self);
  cdsIbptax := TXDataWebDataSet.Create(Self);
  cdsIbptaxid := TIntegerField.Create(Self);
  cdsIbptaxncm_id := TIntegerField.Create(Self);
  cdsIbptaxuf_id := TIntegerField.Create(Self);
  cdsIbptaxtipo := TIntegerField.Create(Self);
  cdsIbptaxaliquota_federal := TFloatField.Create(Self);
  cdsIbptaxaliquota_importacao_federal := TFloatField.Create(Self);
  cdsIbptaxaliquota_estadual := TFloatField.Create(Self);
  cdsIbptaxaliquota_municipal := TFloatField.Create(Self);
  cdsIbptaxdata_vigencia_inicio := TDateTimeField.Create(Self);
  cdsIbptaxdata_vigencia_fim := TDateTimeField.Create(Self);
  cdsIbptaxchave := TStringField.Create(Self);
  cdsIbptaxversao := TStringField.Create(Self);
  cdsIbptaxfonte := TStringField.Create(Self);
  cdsIbptaxexcluido := TBooleanField.Create(Self);
  cdsIbptaxinclusao := TDateTimeField.Create(Self);
  cdsIbptaxalteracao := TDateTimeField.Create(Self);
  cdsIbptaxexclusao := TDateTimeField.Create(Self);
  cdsIbptaxufSigla := TXDataWebDatasetField.Create(Self);
  tmrConsultaIbptax := TTimer.Create(Self);
  dtsIbptaxEdit := TDataSource.Create(Self);
  cdsIbptaxEdit := TXDataWebDataSet.Create(Self);
  cdsIbptaxEditid := TIntegerField.Create(Self);
  cdsIbptaxEditncm_id := TIntegerField.Create(Self);
  cdsIbptaxEdituf_id := TIntegerField.Create(Self);
  cdsIbptaxEdittipo := TIntegerField.Create(Self);
  cdsIbptaxEditaliquota_federal := TFloatField.Create(Self);
  cdsIbptaxEditaliquota_importacao_federal := TFloatField.Create(Self);
  cdsIbptaxEditaliquota_estadual := TFloatField.Create(Self);
  cdsIbptaxEditaliquota_municipal := TFloatField.Create(Self);
  cdsIbptaxEditdata_vigencia_inicio := TDateTimeField.Create(Self);
  cdsIbptaxEditdata_vigencia_fim := TDateTimeField.Create(Self);
  cdsIbptaxEditchave := TStringField.Create(Self);
  cdsIbptaxEditversao := TStringField.Create(Self);
  cdsIbptaxEditfonte := TStringField.Create(Self);
  cdsIbptaxEditexcluido := TBooleanField.Create(Self);
  cdsIbptaxEditinclusao := TDateTimeField.Create(Self);
  cdsIbptaxEditalteracao := TDateTimeField.Create(Self);
  cdsIbptaxEditexclusao := TDateTimeField.Create(Self);
  cdsIbptaxEditufSigla := TXDataWebDatasetField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbncm.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lbdata_inicio_vigencia.BeforeLoadDFMValues;
  lbdata_fim_vigencia.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbTotalIbptax.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  lbtipo.BeforeLoadDFMValues;
  lbaliquota_federal.BeforeLoadDFMValues;
  lbaliquota_importacao_federal.BeforeLoadDFMValues;
  lbaliquota_estadual.BeforeLoadDFMValues;
  lbaliquota_municipal.BeforeLoadDFMValues;
  lbdata_vigencia_inicio.BeforeLoadDFMValues;
  lbdata_vigencia_fim.BeforeLoadDFMValues;
  lbchave.BeforeLoadDFMValues;
  lbversao.BeforeLoadDFMValues;
  lbfonte.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  lbuf_id.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edncm.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  btnIbptaxTab.BeforeLoadDFMValues;
  btnNcmTab.BeforeLoadDFMValues;
  pnlEspacoFormNcm.BeforeLoadDFMValues;
  pnlIbptax.BeforeLoadDFMValues;
  cbPageSizeIbptax.BeforeLoadDFMValues;
  ibptax_search.BeforeLoadDFMValues;
  tblIbptax.BeforeLoadDFMValues;
  wlcIbptax.BeforeLoadDFMValues;
  pnlEspacoFormIbptax.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  edaliquota_federal.BeforeLoadDFMValues;
  edaliquota_importacao_federal.BeforeLoadDFMValues;
  edaliquota_estadual.BeforeLoadDFMValues;
  edaliquota_municipal.BeforeLoadDFMValues;
  eddata_vigencia_inicio.BeforeLoadDFMValues;
  eddata_vigencia_fim.BeforeLoadDFMValues;
  edchave.BeforeLoadDFMValues;
  edversao.BeforeLoadDFMValues;
  edfonte.BeforeLoadDFMValues;
  cbbTipo.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  cbExcluidoIbptax.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  edtUfSigla.BeforeLoadDFMValues;
  eddata_inicio_vigencia.BeforeLoadDFMValues;
  eddata_fim_vigencia.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  NcmDataset.BeforeLoadDFMValues;
  NcmDatasetid.BeforeLoadDFMValues;
  NcmDatasetncm.BeforeLoadDFMValues;
  NcmDatasetdescricao.BeforeLoadDFMValues;
  NcmDatasetdata_inicio_vigencia.BeforeLoadDFMValues;
  NcmDatasetdata_fim_vigencia.BeforeLoadDFMValues;
  NcmDatasetexcluido.BeforeLoadDFMValues;
  NcmDatasetinclusao.BeforeLoadDFMValues;
  NcmDatasetalteracao.BeforeLoadDFMValues;
  NcmDatasetexclusao.BeforeLoadDFMValues;
  XDataClientNcmGet.BeforeLoadDFMValues;
  dtsIbptax.BeforeLoadDFMValues;
  cdsIbptax.BeforeLoadDFMValues;
  cdsIbptaxid.BeforeLoadDFMValues;
  cdsIbptaxncm_id.BeforeLoadDFMValues;
  cdsIbptaxuf_id.BeforeLoadDFMValues;
  cdsIbptaxtipo.BeforeLoadDFMValues;
  cdsIbptaxaliquota_federal.BeforeLoadDFMValues;
  cdsIbptaxaliquota_importacao_federal.BeforeLoadDFMValues;
  cdsIbptaxaliquota_estadual.BeforeLoadDFMValues;
  cdsIbptaxaliquota_municipal.BeforeLoadDFMValues;
  cdsIbptaxdata_vigencia_inicio.BeforeLoadDFMValues;
  cdsIbptaxdata_vigencia_fim.BeforeLoadDFMValues;
  cdsIbptaxchave.BeforeLoadDFMValues;
  cdsIbptaxversao.BeforeLoadDFMValues;
  cdsIbptaxfonte.BeforeLoadDFMValues;
  cdsIbptaxexcluido.BeforeLoadDFMValues;
  cdsIbptaxinclusao.BeforeLoadDFMValues;
  cdsIbptaxalteracao.BeforeLoadDFMValues;
  cdsIbptaxexclusao.BeforeLoadDFMValues;
  cdsIbptaxufSigla.BeforeLoadDFMValues;
  tmrConsultaIbptax.BeforeLoadDFMValues;
  dtsIbptaxEdit.BeforeLoadDFMValues;
  cdsIbptaxEdit.BeforeLoadDFMValues;
  cdsIbptaxEditid.BeforeLoadDFMValues;
  cdsIbptaxEditncm_id.BeforeLoadDFMValues;
  cdsIbptaxEdituf_id.BeforeLoadDFMValues;
  cdsIbptaxEdittipo.BeforeLoadDFMValues;
  cdsIbptaxEditaliquota_federal.BeforeLoadDFMValues;
  cdsIbptaxEditaliquota_importacao_federal.BeforeLoadDFMValues;
  cdsIbptaxEditaliquota_estadual.BeforeLoadDFMValues;
  cdsIbptaxEditaliquota_municipal.BeforeLoadDFMValues;
  cdsIbptaxEditdata_vigencia_inicio.BeforeLoadDFMValues;
  cdsIbptaxEditdata_vigencia_fim.BeforeLoadDFMValues;
  cdsIbptaxEditchave.BeforeLoadDFMValues;
  cdsIbptaxEditversao.BeforeLoadDFMValues;
  cdsIbptaxEditfonte.BeforeLoadDFMValues;
  cdsIbptaxEditexcluido.BeforeLoadDFMValues;
  cdsIbptaxEditinclusao.BeforeLoadDFMValues;
  cdsIbptaxEditalteracao.BeforeLoadDFMValues;
  cdsIbptaxEditexclusao.BeforeLoadDFMValues;
  cdsIbptaxEditufSigla.BeforeLoadDFMValues;
  try
    Name := 'FViewNcmEdit';
    Top := 104;
    Width := 691;
    Height := 965;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 32;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbncm.SetParentComponent(Self);
    lbncm.Name := 'lbncm';
    lbncm.Left := 8;
    lbncm.Top := 59;
    lbncm.Width := 24;
    lbncm.Height := 13;
    lbncm.Caption := 'Ncm:';
    lbncm.HeightPercent := 100.000000000000000000;
    lbncm.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 8;
    lbdescricao.Top := 86;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lbdata_inicio_vigencia.SetParentComponent(Self);
    lbdata_inicio_vigencia.Name := 'lbdata_inicio_vigencia';
    lbdata_inicio_vigencia.Left := 8;
    lbdata_inicio_vigencia.Top := 113;
    lbdata_inicio_vigencia.Width := 71;
    lbdata_inicio_vigencia.Height := 13;
    lbdata_inicio_vigencia.Caption := 'In'#237'cio Vig'#234'ncia:';
    lbdata_inicio_vigencia.HeightPercent := 100.000000000000000000;
    lbdata_inicio_vigencia.WidthPercent := 100.000000000000000000;
    lbdata_fim_vigencia.SetParentComponent(Self);
    lbdata_fim_vigencia.Name := 'lbdata_fim_vigencia';
    lbdata_fim_vigencia.Left := 8;
    lbdata_fim_vigencia.Top := 140;
    lbdata_fim_vigencia.Width := 62;
    lbdata_fim_vigencia.Height := 13;
    lbdata_fim_vigencia.Caption := 'Fim Vig'#234'ncia:';
    lbdata_fim_vigencia.HeightPercent := 100.000000000000000000;
    lbdata_fim_vigencia.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 8;
    lbexcluido.Top := 167;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 8;
    lbinclusao.Top := 194;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 8;
    lbalteracao.Top := 221;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 8;
    lbexclusao.Top := 248;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbTotalIbptax.SetParentComponent(Self);
    lbTotalIbptax.Name := 'lbTotalIbptax';
    lbTotalIbptax.Left := 344;
    lbTotalIbptax.Top := 218;
    lbTotalIbptax.Width := 141;
    lbTotalIbptax.Height := 13;
    lbTotalIbptax.Caption := 'Showing 1 to 10 of 57 entries';
    lbTotalIbptax.HeightPercent := 100.000000000000000000;
    lbTotalIbptax.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 378;
    WebLabel1.Width := 23;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'C'#243'd:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    lbtipo.SetParentComponent(Self);
    lbtipo.Name := 'lbtipo';
    lbtipo.Left := 16;
    lbtipo.Top := 408;
    lbtipo.Width := 24;
    lbtipo.Height := 13;
    lbtipo.Caption := 'Tipo:';
    lbtipo.HeightPercent := 100.000000000000000000;
    lbtipo.WidthPercent := 100.000000000000000000;
    lbaliquota_federal.SetParentComponent(Self);
    lbaliquota_federal.Name := 'lbaliquota_federal';
    lbaliquota_federal.Left := 192;
    lbaliquota_federal.Top := 378;
    lbaliquota_federal.Width := 82;
    lbaliquota_federal.Height := 13;
    lbaliquota_federal.Caption := 'Al'#237'quota Federal:';
    lbaliquota_federal.HeightPercent := 100.000000000000000000;
    lbaliquota_federal.WidthPercent := 100.000000000000000000;
    lbaliquota_importacao_federal.SetParentComponent(Self);
    lbaliquota_importacao_federal.Name := 'lbaliquota_importacao_federal';
    lbaliquota_importacao_federal.Left := 192;
    lbaliquota_importacao_federal.Top := 408;
    lbaliquota_importacao_federal.Width := 101;
    lbaliquota_importacao_federal.Height := 13;
    lbaliquota_importacao_federal.Caption := 'Al'#237'quota Importa'#231#227'o:';
    lbaliquota_importacao_federal.HeightPercent := 100.000000000000000000;
    lbaliquota_importacao_federal.WidthPercent := 100.000000000000000000;
    lbaliquota_estadual.SetParentComponent(Self);
    lbaliquota_estadual.Name := 'lbaliquota_estadual';
    lbaliquota_estadual.Left := 192;
    lbaliquota_estadual.Top := 436;
    lbaliquota_estadual.Width := 87;
    lbaliquota_estadual.Height := 13;
    lbaliquota_estadual.Caption := 'Al'#237'quota Estadual:';
    lbaliquota_estadual.HeightPercent := 100.000000000000000000;
    lbaliquota_estadual.WidthPercent := 100.000000000000000000;
    lbaliquota_municipal.SetParentComponent(Self);
    lbaliquota_municipal.Name := 'lbaliquota_municipal';
    lbaliquota_municipal.Left := 192;
    lbaliquota_municipal.Top := 463;
    lbaliquota_municipal.Width := 89;
    lbaliquota_municipal.Height := 13;
    lbaliquota_municipal.Caption := 'Al'#237'quota Municipal:';
    lbaliquota_municipal.HeightPercent := 100.000000000000000000;
    lbaliquota_municipal.WidthPercent := 100.000000000000000000;
    lbdata_vigencia_inicio.SetParentComponent(Self);
    lbdata_vigencia_inicio.Name := 'lbdata_vigencia_inicio';
    lbdata_vigencia_inicio.Left := 192;
    lbdata_vigencia_inicio.Top := 493;
    lbdata_vigencia_inicio.Width := 71;
    lbdata_vigencia_inicio.Height := 13;
    lbdata_vigencia_inicio.Caption := 'In'#237'cio Vig'#234'ncia:';
    lbdata_vigencia_inicio.HeightPercent := 100.000000000000000000;
    lbdata_vigencia_inicio.WidthPercent := 100.000000000000000000;
    lbdata_vigencia_fim.SetParentComponent(Self);
    lbdata_vigencia_fim.Name := 'lbdata_vigencia_fim';
    lbdata_vigencia_fim.Left := 192;
    lbdata_vigencia_fim.Top := 520;
    lbdata_vigencia_fim.Width := 62;
    lbdata_vigencia_fim.Height := 13;
    lbdata_vigencia_fim.Caption := 'Fim Vig'#234'ncia:';
    lbdata_vigencia_fim.HeightPercent := 100.000000000000000000;
    lbdata_vigencia_fim.WidthPercent := 100.000000000000000000;
    lbchave.SetParentComponent(Self);
    lbchave.Name := 'lbchave';
    lbchave.Left := 16;
    lbchave.Top := 435;
    lbchave.Width := 35;
    lbchave.Height := 13;
    lbchave.Caption := 'Chave:';
    lbchave.HeightPercent := 100.000000000000000000;
    lbchave.WidthPercent := 100.000000000000000000;
    lbversao.SetParentComponent(Self);
    lbversao.Name := 'lbversao';
    lbversao.Left := 17;
    lbversao.Top := 465;
    lbversao.Width := 37;
    lbversao.Height := 13;
    lbversao.Caption := 'Vers'#227'o:';
    lbversao.HeightPercent := 100.000000000000000000;
    lbversao.WidthPercent := 100.000000000000000000;
    lbfonte.SetParentComponent(Self);
    lbfonte.Name := 'lbfonte';
    lbfonte.Left := 16;
    lbfonte.Top := 492;
    lbfonte.Width := 32;
    lbfonte.Height := 13;
    lbfonte.Caption := 'Fonte:';
    lbfonte.HeightPercent := 100.000000000000000000;
    lbfonte.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 520;
    WebLabel3.Width := 44;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Inclus'#227'o:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 16;
    WebLabel2.Top := 549;
    WebLabel2.Width := 44;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Exclu'#237'do?';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 192;
    WebLabel5.Top := 549;
    WebLabel5.Width := 46;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Exclus'#227'o:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 192;
    WebLabel4.Top := 576;
    WebLabel4.Width := 50;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Altera'#231#227'o:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    lbuf_id.SetParentComponent(Self);
    lbuf_id.Name := 'lbuf_id';
    lbuf_id.Left := 16;
    lbuf_id.Top := 576;
    lbuf_id.Width := 15;
    lbuf_id.Height := 13;
    lbuf_id.Caption := 'Uf:';
    lbuf_id.HeightPercent := 100.000000000000000000;
    lbuf_id.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 223;
    btCancel.Top := 93;
    btCancel.Width := 90;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 223;
    btSave.Top := 62;
    btSave.Width := 90;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 101;
    edid.Top := 29;
    edid.Width := 116;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edncm.SetParentComponent(Self);
    edncm.Name := 'edncm';
    edncm.Left := 101;
    edncm.Top := 56;
    edncm.Width := 116;
    edncm.Height := 21;
    edncm.HeightPercent := 100.000000000000000000;
    edncm.MaxLength := 10;
    edncm.TabOrder := 7;
    edncm.Text := 'edncm';
    edncm.WidthPercent := 100.000000000000000000;
    SetEvent(edncm, Self, 'OnClick', 'edncmClick');
    SetEvent(edncm, Self, 'OnKeyPress', 'edncmKeyPress');
    edncm.DataField := 'ncm';
    edncm.DataSource := DataSource;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 101;
    eddescricao.Top := 83;
    eddescricao.Width := 116;
    eddescricao.Height := 21;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 8;
    eddescricao.Text := 'eddescricao';
    eddescricao.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao, Self, 'OnClick', 'eddescricaoClick');
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 101;
    edinclusao.Top := 191;
    edinclusao.Width := 116;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 12;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 101;
    edalteracao.Top := 218;
    edalteracao.Width := 116;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 13;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 101;
    edexclusao.Top := 245;
    edexclusao.Width := 116;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 14;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 101;
    cbExcluido.Top := 163;
    cbExcluido.Width := 99;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    btnIbptaxTab.SetParentComponent(Self);
    btnIbptaxTab.Name := 'btnIbptaxTab';
    btnIbptaxTab.Left := 583;
    btnIbptaxTab.Top := 27;
    btnIbptaxTab.Width := 96;
    btnIbptaxTab.Height := 25;
    btnIbptaxTab.Caption := 'IBPTAX';
    btnIbptaxTab.ChildOrder := 16;
    btnIbptaxTab.HeightPercent := 100.000000000000000000;
    btnIbptaxTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnIbptaxTab, Self, 'OnClick', 'btnIbptaxTabClick');
    btnNcmTab.SetParentComponent(Self);
    btnNcmTab.Name := 'btnNcmTab';
    btnNcmTab.Left := 223;
    btnNcmTab.Top := 31;
    btnNcmTab.Width := 90;
    btnNcmTab.Height := 25;
    btnNcmTab.Caption := 'NCM';
    btnNcmTab.ChildOrder := 16;
    btnNcmTab.HeightPercent := 100.000000000000000000;
    btnNcmTab.WidthPercent := 100.000000000000000000;
    pnlEspacoFormNcm.SetParentComponent(Self);
    pnlEspacoFormNcm.Name := 'pnlEspacoFormNcm';
    pnlEspacoFormNcm.Left := 8;
    pnlEspacoFormNcm.Top := 8;
    pnlEspacoFormNcm.Width := 305;
    pnlEspacoFormNcm.Height := 17;
    pnlEspacoFormNcm.Caption := 'Espa'#231'o form Ncm';
    pnlEspacoFormNcm.ChildOrder := 23;
    pnlEspacoFormNcm.Color := clInfoText;
    pnlEspacoFormNcm.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoFormNcm.Font.Color := clWhite;
    pnlEspacoFormNcm.Font.Height := -11;
    pnlEspacoFormNcm.Font.Name := 'Tahoma';
    pnlEspacoFormNcm.Font.Style := [fsBold];
    pnlEspacoFormNcm.ParentFont := False;
    pnlEspacoFormNcm.TabOrder := 11;
    pnlEspacoFormNcm.Visible := False;
    pnlIbptax.SetParentComponent(Self);
    pnlIbptax.Name := 'pnlIbptax';
    pnlIbptax.Left := 336;
    pnlIbptax.Top := 8;
    pnlIbptax.Width := 343;
    pnlIbptax.Height := 17;
    pnlIbptax.Caption := 'Espa'#231'o tabela ibptax';
    pnlIbptax.ChildOrder := 23;
    pnlIbptax.Color := clInfoText;
    pnlIbptax.Font.Charset := DEFAULT_CHARSET;
    pnlIbptax.Font.Color := clWhite;
    pnlIbptax.Font.Height := -11;
    pnlIbptax.Font.Name := 'Tahoma';
    pnlIbptax.Font.Style := [fsBold];
    pnlIbptax.ParentFont := False;
    pnlIbptax.TabOrder := 12;
    pnlIbptax.Visible := False;
    cbPageSizeIbptax.SetParentComponent(Self);
    cbPageSizeIbptax.Name := 'cbPageSizeIbptax';
    cbPageSizeIbptax.Left := 480;
    cbPageSizeIbptax.Top := 31;
    cbPageSizeIbptax.Width := 97;
    cbPageSizeIbptax.Height := 21;
    cbPageSizeIbptax.HeightPercent := 100.000000000000000000;
    cbPageSizeIbptax.TabOrder := 2;
    cbPageSizeIbptax.Text := '10';
    cbPageSizeIbptax.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeIbptax, Self, 'OnChange', 'cbPageSizeIbptaxChange');
    cbPageSizeIbptax.ItemIndex := 0;
    cbPageSizeIbptax.Items.BeginUpdate;
    try
      cbPageSizeIbptax.Items.Clear;
      cbPageSizeIbptax.Items.Add('10');
      cbPageSizeIbptax.Items.Add('25');
      cbPageSizeIbptax.Items.Add('50');
      cbPageSizeIbptax.Items.Add('100');
    finally
      cbPageSizeIbptax.Items.EndUpdate;
    end;
    ibptax_search.SetParentComponent(Self);
    ibptax_search.Name := 'ibptax_search';
    ibptax_search.Left := 344;
    ibptax_search.Top := 31;
    ibptax_search.Width := 88;
    ibptax_search.Height := 21;
    ibptax_search.ChildOrder := 21;
    ibptax_search.HeightPercent := 100.000000000000000000;
    ibptax_search.TabOrder := 3;
    ibptax_search.WidthPercent := 100.000000000000000000;
    SetEvent(ibptax_search, Self, 'OnKeyDown', 'ibptax_searchKeyDown');
    SetEvent(ibptax_search, Self, 'OnKeyUp', 'ibptax_searchKeyUp');
    tblIbptax.SetParentComponent(Self);
    tblIbptax.Name := 'tblIbptax';
    tblIbptax.Left := 344;
    tblIbptax.Top := 58;
    tblIbptax.Width := 335;
    tblIbptax.Height := 143;
    tblIbptax.ElementClassName := 'table-responsive';
    tblIbptax.BorderColor := clSilver;
    tblIbptax.ChildOrder := 19;
    tblIbptax.ColHeader := False;
    tblIbptax.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblIbptax, Self, 'OnGetCellData', 'tblIbptaxGetCellData');
    SetEvent(tblIbptax, Self, 'OnGetCellChildren', 'tblIbptaxGetCellChildren');
    SetEvent(tblIbptax, Self, 'OnGetCellClass', 'tblIbptaxGetCellClass');
    tblIbptax.Columns.Clear;
    with tblIbptax.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'uf.Sigla';
      Title := 'UF';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'tipo';
      Title := 'Tipo';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'aliquota_federal';
      Title := 'A. Federal';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'aliquota_importacao_federal';
      Title := 'A. Importa'#231#227'o';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'aliquota_estadual';
      Title := 'A.Estadual';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'aliquota_municipal';
      Title := 'A.Municipal';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'data_vigencia_inicio';
      Title := 'In'#237'cio Vig'#234'ncia';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'data_vigencia_fim';
      Title := 'Fim Vig'#234'ncia';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'chave';
      Title := 'chave';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'versao';
      Title := 'Vers'#227'o';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'fonte';
      Title := 'fonte';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with tblIbptax.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    tblIbptax.DataSource := dtsIbptax;
    wlcIbptax.SetParentComponent(Self);
    wlcIbptax.Name := 'wlcIbptax';
    wlcIbptax.Left := 491;
    wlcIbptax.Top := 216;
    wlcIbptax.Width := 188;
    wlcIbptax.Height := 15;
    wlcIbptax.HeightPercent := 100.000000000000000000;
    wlcIbptax.WidthPercent := 100.000000000000000000;
    wlcIbptax.ChildOrder := 24;
    wlcIbptax.DefaultItemClassName := 'page-item';
    wlcIbptax.DefaultItemLinkClassName := 'page-link';
    wlcIbptax.ElementListClassName := 'pagination';
    wlcIbptax.Items.Clear;
    with wlcIbptax.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcIbptax.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcIbptax.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcIbptax.Style := lsPagination;
    pnlEspacoFormIbptax.SetParentComponent(Self);
    pnlEspacoFormIbptax.Name := 'pnlEspacoFormIbptax';
    pnlEspacoFormIbptax.Left := 8;
    pnlEspacoFormIbptax.Top := 352;
    pnlEspacoFormIbptax.Width := 671;
    pnlEspacoFormIbptax.Height := 17;
    pnlEspacoFormIbptax.Caption := 'Espa'#231'o form ibptax';
    pnlEspacoFormIbptax.ChildOrder := 23;
    pnlEspacoFormIbptax.Color := clInfoText;
    pnlEspacoFormIbptax.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoFormIbptax.Font.Color := clWhite;
    pnlEspacoFormIbptax.Font.Height := -11;
    pnlEspacoFormIbptax.Font.Name := 'Tahoma';
    pnlEspacoFormIbptax.Font.Style := [fsBold];
    pnlEspacoFormIbptax.ParentFont := False;
    pnlEspacoFormIbptax.TabOrder := 17;
    pnlEspacoFormIbptax.Visible := False;
    WebDBEdit1.SetParentComponent(Self);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 69;
    WebDBEdit1.Top := 375;
    WebDBEdit1.Width := 88;
    WebDBEdit1.Height := 21;
    WebDBEdit1.ChildOrder := 31;
    WebDBEdit1.Enabled := False;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.TabOrder := 6;
    WebDBEdit1.Text := 'edid';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'id';
    WebDBEdit1.DataSource := dtsIbptaxEdit;
    edaliquota_federal.SetParentComponent(Self);
    edaliquota_federal.Name := 'edaliquota_federal';
    edaliquota_federal.Left := 301;
    edaliquota_federal.Top := 375;
    edaliquota_federal.Width := 156;
    edaliquota_federal.Height := 21;
    edaliquota_federal.ChildOrder := 39;
    edaliquota_federal.Enabled := False;
    edaliquota_federal.HeightPercent := 100.000000000000000000;
    edaliquota_federal.TabOrder := 10;
    edaliquota_federal.Text := 'edaliquota_federal';
    edaliquota_federal.WidthPercent := 100.000000000000000000;
    edaliquota_federal.DataField := 'aliquota_federal';
    edaliquota_federal.DataSource := dtsIbptaxEdit;
    edaliquota_importacao_federal.SetParentComponent(Self);
    edaliquota_importacao_federal.Name := 'edaliquota_importacao_federal';
    edaliquota_importacao_federal.Left := 301;
    edaliquota_importacao_federal.Top := 405;
    edaliquota_importacao_federal.Width := 156;
    edaliquota_importacao_federal.Height := 21;
    edaliquota_importacao_federal.ChildOrder := 41;
    edaliquota_importacao_federal.Enabled := False;
    edaliquota_importacao_federal.HeightPercent := 100.000000000000000000;
    edaliquota_importacao_federal.TabOrder := 11;
    edaliquota_importacao_federal.Text := 'edaliquota_importacao_federal';
    edaliquota_importacao_federal.WidthPercent := 100.000000000000000000;
    edaliquota_importacao_federal.DataField := 'aliquota_importacao_federal';
    edaliquota_importacao_federal.DataSource := dtsIbptaxEdit;
    edaliquota_estadual.SetParentComponent(Self);
    edaliquota_estadual.Name := 'edaliquota_estadual';
    edaliquota_estadual.Left := 301;
    edaliquota_estadual.Top := 433;
    edaliquota_estadual.Width := 156;
    edaliquota_estadual.Height := 21;
    edaliquota_estadual.ChildOrder := 43;
    edaliquota_estadual.Enabled := False;
    edaliquota_estadual.HeightPercent := 100.000000000000000000;
    edaliquota_estadual.TabOrder := 12;
    edaliquota_estadual.Text := 'edaliquota_estadual';
    edaliquota_estadual.WidthPercent := 100.000000000000000000;
    edaliquota_estadual.DataField := 'aliquota_estadual';
    edaliquota_estadual.DataSource := dtsIbptaxEdit;
    edaliquota_municipal.SetParentComponent(Self);
    edaliquota_municipal.Name := 'edaliquota_municipal';
    edaliquota_municipal.Left := 301;
    edaliquota_municipal.Top := 460;
    edaliquota_municipal.Width := 156;
    edaliquota_municipal.Height := 21;
    edaliquota_municipal.ChildOrder := 45;
    edaliquota_municipal.Enabled := False;
    edaliquota_municipal.HeightPercent := 100.000000000000000000;
    edaliquota_municipal.TabOrder := 13;
    edaliquota_municipal.Text := 'edaliquota_municipal';
    edaliquota_municipal.WidthPercent := 100.000000000000000000;
    edaliquota_municipal.DataField := 'aliquota_municipal';
    edaliquota_municipal.DataSource := dtsIbptaxEdit;
    eddata_vigencia_inicio.SetParentComponent(Self);
    eddata_vigencia_inicio.Name := 'eddata_vigencia_inicio';
    eddata_vigencia_inicio.Left := 301;
    eddata_vigencia_inicio.Top := 490;
    eddata_vigencia_inicio.Width := 156;
    eddata_vigencia_inicio.Height := 21;
    eddata_vigencia_inicio.ChildOrder := 47;
    eddata_vigencia_inicio.Enabled := False;
    eddata_vigencia_inicio.HeightPercent := 100.000000000000000000;
    eddata_vigencia_inicio.TabOrder := 14;
    eddata_vigencia_inicio.Text := 'eddata_vigencia_inicio';
    eddata_vigencia_inicio.WidthPercent := 100.000000000000000000;
    eddata_vigencia_inicio.DataField := 'data_vigencia_inicio';
    eddata_vigencia_inicio.DataSource := dtsIbptaxEdit;
    eddata_vigencia_fim.SetParentComponent(Self);
    eddata_vigencia_fim.Name := 'eddata_vigencia_fim';
    eddata_vigencia_fim.Left := 301;
    eddata_vigencia_fim.Top := 517;
    eddata_vigencia_fim.Width := 156;
    eddata_vigencia_fim.Height := 21;
    eddata_vigencia_fim.ChildOrder := 49;
    eddata_vigencia_fim.Enabled := False;
    eddata_vigencia_fim.HeightPercent := 100.000000000000000000;
    eddata_vigencia_fim.TabOrder := 15;
    eddata_vigencia_fim.Text := 'eddata_vigencia_fim';
    eddata_vigencia_fim.WidthPercent := 100.000000000000000000;
    eddata_vigencia_fim.DataField := 'data_vigencia_fim';
    eddata_vigencia_fim.DataSource := dtsIbptaxEdit;
    edchave.SetParentComponent(Self);
    edchave.Name := 'edchave';
    edchave.Left := 69;
    edchave.Top := 432;
    edchave.Width := 88;
    edchave.Height := 21;
    edchave.ChildOrder := 51;
    edchave.Enabled := False;
    edchave.HeightPercent := 100.000000000000000000;
    edchave.TabOrder := 16;
    edchave.Text := 'edchave';
    edchave.WidthPercent := 100.000000000000000000;
    edchave.DataField := 'chave';
    edchave.DataSource := dtsIbptaxEdit;
    edversao.SetParentComponent(Self);
    edversao.Name := 'edversao';
    edversao.Left := 69;
    edversao.Top := 462;
    edversao.Width := 88;
    edversao.Height := 21;
    edversao.ChildOrder := 53;
    edversao.Enabled := False;
    edversao.HeightPercent := 100.000000000000000000;
    edversao.TabOrder := 17;
    edversao.Text := 'edversao';
    edversao.WidthPercent := 100.000000000000000000;
    edversao.DataField := 'versao';
    edversao.DataSource := dtsIbptaxEdit;
    edfonte.SetParentComponent(Self);
    edfonte.Name := 'edfonte';
    edfonte.Left := 69;
    edfonte.Top := 489;
    edfonte.Width := 88;
    edfonte.Height := 21;
    edfonte.ChildOrder := 55;
    edfonte.Enabled := False;
    edfonte.HeightPercent := 100.000000000000000000;
    edfonte.TabOrder := 18;
    edfonte.Text := 'edfonte';
    edfonte.WidthPercent := 100.000000000000000000;
    edfonte.DataField := 'fonte';
    edfonte.DataSource := dtsIbptaxEdit;
    cbbTipo.SetParentComponent(Self);
    cbbTipo.Name := 'cbbTipo';
    cbbTipo.Left := 69;
    cbbTipo.Top := 405;
    cbbTipo.Width := 88;
    cbbTipo.Height := 21;
    cbbTipo.Enabled := False;
    cbbTipo.HeightPercent := 100.000000000000000000;
    cbbTipo.TabOrder := 3;
    cbbTipo.WidthPercent := 100.000000000000000000;
    cbbTipo.ItemIndex := 2;
    cbbTipo.Items.BeginUpdate;
    try
      cbbTipo.Items.Clear;
      cbbTipo.Items.Add('Produtos');
      cbbTipo.Items.Add('Servi'#231'os');
      cbbTipo.Items.Add('');
    finally
      cbbTipo.Items.EndUpdate;
    end;
    WebDBEdit2.SetParentComponent(Self);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 69;
    WebDBEdit2.Top := 517;
    WebDBEdit2.Width := 88;
    WebDBEdit2.Height := 21;
    WebDBEdit2.ChildOrder := 59;
    WebDBEdit2.Enabled := False;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.TabOrder := 20;
    WebDBEdit2.Text := 'edinclusao';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'inclusao';
    WebDBEdit2.DataSource := dtsIbptaxEdit;
    cbExcluidoIbptax.SetParentComponent(Self);
    cbExcluidoIbptax.Name := 'cbExcluidoIbptax';
    cbExcluidoIbptax.Left := 69;
    cbExcluidoIbptax.Top := 546;
    cbExcluidoIbptax.Width := 88;
    cbExcluidoIbptax.Height := 22;
    cbExcluidoIbptax.Caption := 'cbExcluidoIbptax';
    cbExcluidoIbptax.ChildOrder := 13;
    cbExcluidoIbptax.Enabled := False;
    cbExcluidoIbptax.HeightPercent := 100.000000000000000000;
    cbExcluidoIbptax.WidthPercent := 100.000000000000000000;
    cbExcluidoIbptax.DataField := 'excluido';
    cbExcluidoIbptax.DataSource := dtsIbptaxEdit;
    WebDBEdit4.SetParentComponent(Self);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 304;
    WebDBEdit4.Top := 546;
    WebDBEdit4.Width := 153;
    WebDBEdit4.Height := 21;
    WebDBEdit4.ChildOrder := 63;
    WebDBEdit4.Enabled := False;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.TabOrder := 22;
    WebDBEdit4.Text := 'edexclusao';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'exclusao';
    WebDBEdit4.DataSource := dtsIbptaxEdit;
    WebDBEdit3.SetParentComponent(Self);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 304;
    WebDBEdit3.Top := 573;
    WebDBEdit3.Width := 153;
    WebDBEdit3.Height := 21;
    WebDBEdit3.ChildOrder := 61;
    WebDBEdit3.Enabled := False;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.TabOrder := 21;
    WebDBEdit3.Text := 'edalteracao';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'alteracao';
    WebDBEdit3.DataSource := dtsIbptaxEdit;
    edtUfSigla.SetParentComponent(Self);
    edtUfSigla.Name := 'edtUfSigla';
    edtUfSigla.Left := 69;
    edtUfSigla.Top := 573;
    edtUfSigla.Width := 88;
    edtUfSigla.Height := 21;
    edtUfSigla.ChildOrder := 53;
    edtUfSigla.Enabled := False;
    edtUfSigla.HeightPercent := 100.000000000000000000;
    edtUfSigla.TabOrder := 17;
    edtUfSigla.Text := 'edtUfSigla';
    edtUfSigla.WidthPercent := 100.000000000000000000;
    edtUfSigla.DataField := 'uf.Sigla';
    edtUfSigla.DataSource := dtsIbptaxEdit;
    eddata_inicio_vigencia.SetParentComponent(Self);
    eddata_inicio_vigencia.Name := 'eddata_inicio_vigencia';
    eddata_inicio_vigencia.Left := 101;
    eddata_inicio_vigencia.Top := 109;
    eddata_inicio_vigencia.Width := 116;
    eddata_inicio_vigencia.Height := 22;
    eddata_inicio_vigencia.BorderStyle := bsSingle;
    eddata_inicio_vigencia.ChildOrder := 62;
    eddata_inicio_vigencia.Color := clWhite;
    eddata_inicio_vigencia.Date := 45775.510139409720000000;
    eddata_inicio_vigencia.Role := '';
    eddata_inicio_vigencia.ShowSeconds := False;
    eddata_inicio_vigencia.Text := '';
    SetEvent(eddata_inicio_vigencia, Self, 'OnClick', 'eddata_inicio_vigenciaClick');
    eddata_inicio_vigencia.DataField := 'data_inicio_vigencia';
    eddata_inicio_vigencia.DataSource := DataSource;
    eddata_fim_vigencia.SetParentComponent(Self);
    eddata_fim_vigencia.Name := 'eddata_fim_vigencia';
    eddata_fim_vigencia.Left := 101;
    eddata_fim_vigencia.Top := 135;
    eddata_fim_vigencia.Width := 116;
    eddata_fim_vigencia.Height := 22;
    eddata_fim_vigencia.BorderStyle := bsSingle;
    eddata_fim_vigencia.ChildOrder := 62;
    eddata_fim_vigencia.Color := clWhite;
    eddata_fim_vigencia.Date := 45775.510139409720000000;
    eddata_fim_vigencia.Role := '';
    eddata_fim_vigencia.ShowSeconds := False;
    eddata_fim_vigencia.Text := '';
    SetEvent(eddata_fim_vigencia, Self, 'OnClick', 'eddata_fim_vigenciaClick');
    eddata_fim_vigencia.DataField := 'data_fim_vigencia';
    eddata_fim_vigencia.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := NcmDataset;
    DataSource.Left := 16;
    DataSource.Top := 288;
    NcmDataset.SetParentComponent(Self);
    NcmDataset.Name := 'NcmDataset';
    NcmDataset.AfterApplyUpdates := NcmDatasetAfterApplyUpdates;
    NcmDataset.EntitySetName := 'Ncm';
    NcmDataset.Connection := DMConnection.ApiConnection;
    NcmDataset.Left := 88;
    NcmDataset.Top := 288;
    NcmDatasetid.SetParentComponent(NcmDataset);
    NcmDatasetid.Name := 'NcmDatasetid';
    NcmDatasetid.FieldName := 'id';
    NcmDatasetncm.SetParentComponent(NcmDataset);
    NcmDatasetncm.Name := 'NcmDatasetncm';
    NcmDatasetncm.FieldName := 'ncm';
    NcmDatasetncm.Required := True;
    NcmDatasetncm.Size := 255;
    NcmDatasetdescricao.SetParentComponent(NcmDataset);
    NcmDatasetdescricao.Name := 'NcmDatasetdescricao';
    NcmDatasetdescricao.FieldName := 'descricao';
    NcmDatasetdescricao.Size := 255;
    NcmDatasetdata_inicio_vigencia.SetParentComponent(NcmDataset);
    NcmDatasetdata_inicio_vigencia.Name := 'NcmDatasetdata_inicio_vigencia';
    NcmDatasetdata_inicio_vigencia.FieldName := 'data_inicio_vigencia';
    NcmDatasetdata_inicio_vigencia.DisplayFormat := 'yyyy-MM-dd';
    NcmDatasetdata_fim_vigencia.SetParentComponent(NcmDataset);
    NcmDatasetdata_fim_vigencia.Name := 'NcmDatasetdata_fim_vigencia';
    NcmDatasetdata_fim_vigencia.FieldName := 'data_fim_vigencia';
    NcmDatasetdata_fim_vigencia.DisplayFormat := 'dd/mm/yyyy';
    NcmDatasetexcluido.SetParentComponent(NcmDataset);
    NcmDatasetexcluido.Name := 'NcmDatasetexcluido';
    NcmDatasetexcluido.FieldName := 'excluido';
    NcmDatasetinclusao.SetParentComponent(NcmDataset);
    NcmDatasetinclusao.Name := 'NcmDatasetinclusao';
    NcmDatasetinclusao.FieldName := 'inclusao';
    NcmDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NcmDatasetalteracao.SetParentComponent(NcmDataset);
    NcmDatasetalteracao.Name := 'NcmDatasetalteracao';
    NcmDatasetalteracao.FieldName := 'alteracao';
    NcmDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NcmDatasetexclusao.SetParentComponent(NcmDataset);
    NcmDatasetexclusao.Name := 'NcmDatasetexclusao';
    NcmDatasetexclusao.FieldName := 'exclusao';
    NcmDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientNcmGet.SetParentComponent(Self);
    XDataClientNcmGet.Name := 'XDataClientNcmGet';
    XDataClientNcmGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNcmGet, Self, 'OnLoad', 'XDataClientNcmGetLoad');
    XDataClientNcmGet.Left := 152;
    XDataClientNcmGet.Top := 288;
    dtsIbptax.SetParentComponent(Self);
    dtsIbptax.Name := 'dtsIbptax';
    dtsIbptax.DataSet := cdsIbptax;
    dtsIbptax.Left := 360;
    dtsIbptax.Top := 248;
    cdsIbptax.SetParentComponent(Self);
    cdsIbptax.Name := 'cdsIbptax';
    cdsIbptax.EntitySetName := 'Ncm_Ibptax';
    cdsIbptax.Connection := DMConnection.ApiConnection;
    cdsIbptax.Left := 456;
    cdsIbptax.Top := 248;
    cdsIbptaxid.SetParentComponent(cdsIbptax);
    cdsIbptaxid.Name := 'cdsIbptaxid';
    cdsIbptaxid.FieldName := 'id';
    cdsIbptaxid.Required := True;
    cdsIbptaxncm_id.SetParentComponent(cdsIbptax);
    cdsIbptaxncm_id.Name := 'cdsIbptaxncm_id';
    cdsIbptaxncm_id.FieldName := 'ncm_id';
    cdsIbptaxncm_id.Required := True;
    cdsIbptaxuf_id.SetParentComponent(cdsIbptax);
    cdsIbptaxuf_id.Name := 'cdsIbptaxuf_id';
    cdsIbptaxuf_id.FieldName := 'uf_id';
    cdsIbptaxuf_id.Required := True;
    cdsIbptaxtipo.SetParentComponent(cdsIbptax);
    cdsIbptaxtipo.Name := 'cdsIbptaxtipo';
    cdsIbptaxtipo.FieldName := 'tipo';
    cdsIbptaxaliquota_federal.SetParentComponent(cdsIbptax);
    cdsIbptaxaliquota_federal.Name := 'cdsIbptaxaliquota_federal';
    cdsIbptaxaliquota_federal.FieldName := 'aliquota_federal';
    cdsIbptaxaliquota_federal.DisplayFormat := '0.00';
    cdsIbptaxaliquota_importacao_federal.SetParentComponent(cdsIbptax);
    cdsIbptaxaliquota_importacao_federal.Name := 'cdsIbptaxaliquota_importacao_federal';
    cdsIbptaxaliquota_importacao_federal.FieldName := 'aliquota_importacao_federal';
    cdsIbptaxaliquota_importacao_federal.DisplayFormat := '0.00';
    cdsIbptaxaliquota_estadual.SetParentComponent(cdsIbptax);
    cdsIbptaxaliquota_estadual.Name := 'cdsIbptaxaliquota_estadual';
    cdsIbptaxaliquota_estadual.FieldName := 'aliquota_estadual';
    cdsIbptaxaliquota_estadual.DisplayFormat := '0.00';
    cdsIbptaxaliquota_municipal.SetParentComponent(cdsIbptax);
    cdsIbptaxaliquota_municipal.Name := 'cdsIbptaxaliquota_municipal';
    cdsIbptaxaliquota_municipal.FieldName := 'aliquota_municipal';
    cdsIbptaxaliquota_municipal.DisplayFormat := '0.00';
    cdsIbptaxdata_vigencia_inicio.SetParentComponent(cdsIbptax);
    cdsIbptaxdata_vigencia_inicio.Name := 'cdsIbptaxdata_vigencia_inicio';
    cdsIbptaxdata_vigencia_inicio.FieldName := 'data_vigencia_inicio';
    cdsIbptaxdata_vigencia_inicio.DisplayFormat := 'dd/mm/yyyy';
    cdsIbptaxdata_vigencia_fim.SetParentComponent(cdsIbptax);
    cdsIbptaxdata_vigencia_fim.Name := 'cdsIbptaxdata_vigencia_fim';
    cdsIbptaxdata_vigencia_fim.FieldName := 'data_vigencia_fim';
    cdsIbptaxdata_vigencia_fim.DisplayFormat := 'dd/mm/yyyy';
    cdsIbptaxchave.SetParentComponent(cdsIbptax);
    cdsIbptaxchave.Name := 'cdsIbptaxchave';
    cdsIbptaxchave.FieldName := 'chave';
    cdsIbptaxchave.Size := 255;
    cdsIbptaxversao.SetParentComponent(cdsIbptax);
    cdsIbptaxversao.Name := 'cdsIbptaxversao';
    cdsIbptaxversao.FieldName := 'versao';
    cdsIbptaxversao.Size := 255;
    cdsIbptaxfonte.SetParentComponent(cdsIbptax);
    cdsIbptaxfonte.Name := 'cdsIbptaxfonte';
    cdsIbptaxfonte.FieldName := 'fonte';
    cdsIbptaxfonte.Size := 255;
    cdsIbptaxexcluido.SetParentComponent(cdsIbptax);
    cdsIbptaxexcluido.Name := 'cdsIbptaxexcluido';
    cdsIbptaxexcluido.FieldName := 'excluido';
    cdsIbptaxinclusao.SetParentComponent(cdsIbptax);
    cdsIbptaxinclusao.Name := 'cdsIbptaxinclusao';
    cdsIbptaxinclusao.FieldName := 'inclusao';
    cdsIbptaxinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbptaxalteracao.SetParentComponent(cdsIbptax);
    cdsIbptaxalteracao.Name := 'cdsIbptaxalteracao';
    cdsIbptaxalteracao.FieldName := 'alteracao';
    cdsIbptaxalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbptaxexclusao.SetParentComponent(cdsIbptax);
    cdsIbptaxexclusao.Name := 'cdsIbptaxexclusao';
    cdsIbptaxexclusao.FieldName := 'exclusao';
    cdsIbptaxexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbptaxufSigla.SetParentComponent(cdsIbptax);
    cdsIbptaxufSigla.Name := 'cdsIbptaxufSigla';
    cdsIbptaxufSigla.FieldKind := fkCalculated;
    cdsIbptaxufSigla.FieldName := 'uf.Sigla';
    cdsIbptaxufSigla.Calculated := True;
    tmrConsultaIbptax.SetParentComponent(Self);
    tmrConsultaIbptax.Name := 'tmrConsultaIbptax';
    tmrConsultaIbptax.Enabled := False;
    SetEvent(tmrConsultaIbptax, Self, 'OnTimer', 'tmrConsultaIbptaxTimer');
    tmrConsultaIbptax.Left := 560;
    tmrConsultaIbptax.Top := 248;
    dtsIbptaxEdit.SetParentComponent(Self);
    dtsIbptaxEdit.Name := 'dtsIbptaxEdit';
    dtsIbptaxEdit.DataSet := cdsIbptaxEdit;
    dtsIbptaxEdit.Left := 576;
    dtsIbptaxEdit.Top := 376;
    cdsIbptaxEdit.SetParentComponent(Self);
    cdsIbptaxEdit.Name := 'cdsIbptaxEdit';
    cdsIbptaxEdit.AfterOpen := cdsIbptaxEditAfterOpen;
    cdsIbptaxEdit.EntitySetName := 'Ncm_Ibptax';
    cdsIbptaxEdit.Connection := DMConnection.ApiConnection;
    cdsIbptaxEdit.Left := 496;
    cdsIbptaxEdit.Top := 376;
    cdsIbptaxEditid.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditid.Name := 'cdsIbptaxEditid';
    cdsIbptaxEditid.FieldName := 'id';
    cdsIbptaxEditid.Required := True;
    cdsIbptaxEditncm_id.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditncm_id.Name := 'cdsIbptaxEditncm_id';
    cdsIbptaxEditncm_id.FieldName := 'ncm_id';
    cdsIbptaxEditncm_id.Required := True;
    cdsIbptaxEdituf_id.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEdituf_id.Name := 'cdsIbptaxEdituf_id';
    cdsIbptaxEdituf_id.FieldName := 'uf_id';
    cdsIbptaxEdituf_id.Required := True;
    cdsIbptaxEdittipo.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEdittipo.Name := 'cdsIbptaxEdittipo';
    cdsIbptaxEdittipo.FieldName := 'tipo';
    cdsIbptaxEditaliquota_federal.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditaliquota_federal.Name := 'cdsIbptaxEditaliquota_federal';
    cdsIbptaxEditaliquota_federal.FieldName := 'aliquota_federal';
    cdsIbptaxEditaliquota_federal.DisplayFormat := '0.00';
    cdsIbptaxEditaliquota_importacao_federal.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditaliquota_importacao_federal.Name := 'cdsIbptaxEditaliquota_importacao_federal';
    cdsIbptaxEditaliquota_importacao_federal.FieldName := 'aliquota_importacao_federal';
    cdsIbptaxEditaliquota_importacao_federal.DisplayFormat := '0.00';
    cdsIbptaxEditaliquota_estadual.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditaliquota_estadual.Name := 'cdsIbptaxEditaliquota_estadual';
    cdsIbptaxEditaliquota_estadual.FieldName := 'aliquota_estadual';
    cdsIbptaxEditaliquota_estadual.DisplayFormat := '0.00';
    cdsIbptaxEditaliquota_municipal.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditaliquota_municipal.Name := 'cdsIbptaxEditaliquota_municipal';
    cdsIbptaxEditaliquota_municipal.FieldName := 'aliquota_municipal';
    cdsIbptaxEditaliquota_municipal.DisplayFormat := '0.00';
    cdsIbptaxEditdata_vigencia_inicio.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditdata_vigencia_inicio.Name := 'cdsIbptaxEditdata_vigencia_inicio';
    cdsIbptaxEditdata_vigencia_inicio.FieldName := 'data_vigencia_inicio';
    cdsIbptaxEditdata_vigencia_inicio.DisplayFormat := 'dd/mm/yyyy';
    cdsIbptaxEditdata_vigencia_fim.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditdata_vigencia_fim.Name := 'cdsIbptaxEditdata_vigencia_fim';
    cdsIbptaxEditdata_vigencia_fim.FieldName := 'data_vigencia_fim';
    cdsIbptaxEditdata_vigencia_fim.DisplayFormat := 'dd/mm/yyyy';
    cdsIbptaxEditchave.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditchave.Name := 'cdsIbptaxEditchave';
    cdsIbptaxEditchave.FieldName := 'chave';
    cdsIbptaxEditchave.Size := 255;
    cdsIbptaxEditversao.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditversao.Name := 'cdsIbptaxEditversao';
    cdsIbptaxEditversao.FieldName := 'versao';
    cdsIbptaxEditversao.Size := 255;
    cdsIbptaxEditfonte.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditfonte.Name := 'cdsIbptaxEditfonte';
    cdsIbptaxEditfonte.FieldName := 'fonte';
    cdsIbptaxEditfonte.Size := 255;
    cdsIbptaxEditexcluido.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditexcluido.Name := 'cdsIbptaxEditexcluido';
    cdsIbptaxEditexcluido.FieldName := 'excluido';
    cdsIbptaxEditinclusao.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditinclusao.Name := 'cdsIbptaxEditinclusao';
    cdsIbptaxEditinclusao.FieldName := 'inclusao';
    cdsIbptaxEditinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbptaxEditalteracao.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditalteracao.Name := 'cdsIbptaxEditalteracao';
    cdsIbptaxEditalteracao.FieldName := 'alteracao';
    cdsIbptaxEditalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbptaxEditexclusao.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditexclusao.Name := 'cdsIbptaxEditexclusao';
    cdsIbptaxEditexclusao.FieldName := 'exclusao';
    cdsIbptaxEditexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbptaxEditufSigla.SetParentComponent(cdsIbptaxEdit);
    cdsIbptaxEditufSigla.Name := 'cdsIbptaxEditufSigla';
    cdsIbptaxEditufSigla.FieldKind := fkCalculated;
    cdsIbptaxEditufSigla.FieldName := 'uf.Sigla';
    cdsIbptaxEditufSigla.Calculated := True;
  finally
    lbid.AfterLoadDFMValues;
    lbncm.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lbdata_inicio_vigencia.AfterLoadDFMValues;
    lbdata_fim_vigencia.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbTotalIbptax.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    lbtipo.AfterLoadDFMValues;
    lbaliquota_federal.AfterLoadDFMValues;
    lbaliquota_importacao_federal.AfterLoadDFMValues;
    lbaliquota_estadual.AfterLoadDFMValues;
    lbaliquota_municipal.AfterLoadDFMValues;
    lbdata_vigencia_inicio.AfterLoadDFMValues;
    lbdata_vigencia_fim.AfterLoadDFMValues;
    lbchave.AfterLoadDFMValues;
    lbversao.AfterLoadDFMValues;
    lbfonte.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    lbuf_id.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edncm.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    btnIbptaxTab.AfterLoadDFMValues;
    btnNcmTab.AfterLoadDFMValues;
    pnlEspacoFormNcm.AfterLoadDFMValues;
    pnlIbptax.AfterLoadDFMValues;
    cbPageSizeIbptax.AfterLoadDFMValues;
    ibptax_search.AfterLoadDFMValues;
    tblIbptax.AfterLoadDFMValues;
    wlcIbptax.AfterLoadDFMValues;
    pnlEspacoFormIbptax.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    edaliquota_federal.AfterLoadDFMValues;
    edaliquota_importacao_federal.AfterLoadDFMValues;
    edaliquota_estadual.AfterLoadDFMValues;
    edaliquota_municipal.AfterLoadDFMValues;
    eddata_vigencia_inicio.AfterLoadDFMValues;
    eddata_vigencia_fim.AfterLoadDFMValues;
    edchave.AfterLoadDFMValues;
    edversao.AfterLoadDFMValues;
    edfonte.AfterLoadDFMValues;
    cbbTipo.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    cbExcluidoIbptax.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    edtUfSigla.AfterLoadDFMValues;
    eddata_inicio_vigencia.AfterLoadDFMValues;
    eddata_fim_vigencia.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    NcmDataset.AfterLoadDFMValues;
    NcmDatasetid.AfterLoadDFMValues;
    NcmDatasetncm.AfterLoadDFMValues;
    NcmDatasetdescricao.AfterLoadDFMValues;
    NcmDatasetdata_inicio_vigencia.AfterLoadDFMValues;
    NcmDatasetdata_fim_vigencia.AfterLoadDFMValues;
    NcmDatasetexcluido.AfterLoadDFMValues;
    NcmDatasetinclusao.AfterLoadDFMValues;
    NcmDatasetalteracao.AfterLoadDFMValues;
    NcmDatasetexclusao.AfterLoadDFMValues;
    XDataClientNcmGet.AfterLoadDFMValues;
    dtsIbptax.AfterLoadDFMValues;
    cdsIbptax.AfterLoadDFMValues;
    cdsIbptaxid.AfterLoadDFMValues;
    cdsIbptaxncm_id.AfterLoadDFMValues;
    cdsIbptaxuf_id.AfterLoadDFMValues;
    cdsIbptaxtipo.AfterLoadDFMValues;
    cdsIbptaxaliquota_federal.AfterLoadDFMValues;
    cdsIbptaxaliquota_importacao_federal.AfterLoadDFMValues;
    cdsIbptaxaliquota_estadual.AfterLoadDFMValues;
    cdsIbptaxaliquota_municipal.AfterLoadDFMValues;
    cdsIbptaxdata_vigencia_inicio.AfterLoadDFMValues;
    cdsIbptaxdata_vigencia_fim.AfterLoadDFMValues;
    cdsIbptaxchave.AfterLoadDFMValues;
    cdsIbptaxversao.AfterLoadDFMValues;
    cdsIbptaxfonte.AfterLoadDFMValues;
    cdsIbptaxexcluido.AfterLoadDFMValues;
    cdsIbptaxinclusao.AfterLoadDFMValues;
    cdsIbptaxalteracao.AfterLoadDFMValues;
    cdsIbptaxexclusao.AfterLoadDFMValues;
    cdsIbptaxufSigla.AfterLoadDFMValues;
    tmrConsultaIbptax.AfterLoadDFMValues;
    dtsIbptaxEdit.AfterLoadDFMValues;
    cdsIbptaxEdit.AfterLoadDFMValues;
    cdsIbptaxEditid.AfterLoadDFMValues;
    cdsIbptaxEditncm_id.AfterLoadDFMValues;
    cdsIbptaxEdituf_id.AfterLoadDFMValues;
    cdsIbptaxEdittipo.AfterLoadDFMValues;
    cdsIbptaxEditaliquota_federal.AfterLoadDFMValues;
    cdsIbptaxEditaliquota_importacao_federal.AfterLoadDFMValues;
    cdsIbptaxEditaliquota_estadual.AfterLoadDFMValues;
    cdsIbptaxEditaliquota_municipal.AfterLoadDFMValues;
    cdsIbptaxEditdata_vigencia_inicio.AfterLoadDFMValues;
    cdsIbptaxEditdata_vigencia_fim.AfterLoadDFMValues;
    cdsIbptaxEditchave.AfterLoadDFMValues;
    cdsIbptaxEditversao.AfterLoadDFMValues;
    cdsIbptaxEditfonte.AfterLoadDFMValues;
    cdsIbptaxEditexcluido.AfterLoadDFMValues;
    cdsIbptaxEditinclusao.AfterLoadDFMValues;
    cdsIbptaxEditalteracao.AfterLoadDFMValues;
    cdsIbptaxEditexclusao.AfterLoadDFMValues;
    cdsIbptaxEditufSigla.AfterLoadDFMValues;
  end;
end;

end.
